import AnalysisResultHeader from "./analysisHeader";
import AnalysisResultData from "./analysisResultData";

const AnalysisResultView = ({
  switchTab,
  setSwitchTab,
  currentAnalysisData,
  reportId,
  displayAnalysisResult,
  uniqueProducts,
  highestLiftRule,
  start_date,
  end_date,
  searchQueryForItemsets,
  setSearchQueryForItemsets,
  supportFilter,
  setSupportFilter,
  selectedCombo,
  setSelectedCombo,
  countItemSet,
  sortBy,
  setSortBy,
  setCurrentPage,
  analysisDetailsHistory,
  isLoading,
  selectDesign,
  currentPage,
  //   productsBundles,
  productBundlesData,
  order_details_id,
  isSingleOrderExclude,
  favoriteSkuResponseList,
  setCountItemSet,
  itemSetCounter,
  isDefault
}) => {
  return (
    <>
      <main className={`w-full  mx-auto px-4 py-6 sm:px-6 lg:px-8 ${!isDefault && 'md:w-[78%]'}`}>
        {
          !isDefault &&
          <AnalysisResultHeader
          switchTab={switchTab}
          setSwitchTab={setSwitchTab}
          currentAnalysisData={currentAnalysisData}
          reportId={reportId}
          displayAnalysisResult={displayAnalysisResult}
          highestLiftRule={highestLiftRule}
          uniqueProducts={uniqueProducts}
          start_date={start_date}
          end_date={end_date}
          searchQueryForItemsets={searchQueryForItemsets}
          setSearchQueryForItemsets={setSearchQueryForItemsets}
          supportFilter={supportFilter}
          setSupportFilter={setSupportFilter}
          selectedCombo={selectedCombo}
          setSelectedCombo={setSelectedCombo}
          countItemSet={countItemSet}
          sortBy={sortBy}
          setSortBy={setSortBy}
          setCurrentPage={setCurrentPage}
          order_details_id={order_details_id}
        />
        }

        <AnalysisResultData
          analysisDetailsHistory={analysisDetailsHistory}
          isLoading={isLoading}
          switchTab={switchTab}
          selectDesign={selectDesign}
          displayAnalysisResult={displayAnalysisResult}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          currentAnalysisData={currentAnalysisData}
          productsBundles={productBundlesData}
          order_details_id={order_details_id}
          isSingleOrderExclude={isSingleOrderExclude}
          favoriteSkuResponseList={favoriteSkuResponseList}
          supportFilter={supportFilter}
          sortBy={sortBy}
          searchQueryForItemsets={searchQueryForItemsets}
          setCountItemSet={setCountItemSet}
          selectedCombo={selectedCombo}
          isDefault={isDefault}
        />
      </main>
    </>
  );
};

export default AnalysisResultView;
